import React, {useEffect, useMemo, useState} from 'react';
import Search from "../../../../../../components/search/Search";
import {CacheType, CodeSpecNum} from "../../../../../../constant/CodeSpecNum";
import {deleteAssets, getCommonColumns, getCommonStringColumns} from "../../../../../../api/asset/AssetService";
import {handleActiveError} from "../../../../../../components/sonner/ToastBasic";
import {openDrawer} from "../../../../../../redux/slice/opnerSlice";
import {useDispatch, useSelector} from "react-redux";
import AssetMemo from "./AssetMemo";
import {ASSET_IAM_LIST_HEADER, ASSET_LIST_HEADER} from "../../../../../../components/table/header/Headers";
import SearchSection from "../../../../../../components/search/SearchSection";
import Selector from "../../../../../../components/selector/Selector";
import {
    ITER_searchListener,
    searchListener,
    searchWithChildren
} from "../../../../../../components/commonmethod/simmsDrawerMethod";
import {
    canInsertByLicense,
    extractObject,
    initHeaderOrders,
    simmsColumnsToJsGridHeaders,
    withListColumnFilters,
} from "../../../../../../components/commonmethod/CommonMethod";
import {useExcelDownloadClick} from "../../../../../../components/commonmethod/excelMethod";
import {useCacheRefresh} from "../../../../../../hooks/useCacheRefresh";
import SimmsInputSearch from "../../../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../../../components/drawer/simms/SimmsDrawerSearch";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../../../components/js-grid/SimmsJsGrid";
import {useNavigate} from "react-router-dom";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../../../components/pageTabs/pageTabsStorage";
import {
    getIndividualSetting,
    resetIndividualSetting,
    setIndividualSetting
} from "../../../../../../api/user/UserAccountService";
import JsGridExcelGridOpenButton from "../../../../../../components/js-grid/JsGridExcelGridOpenButton";
import MemoIcon from "../../../../../../resources/icon/memo.png";
import QrIcon from "../../../../../../resources/icon/qr-icon.png";

function AssetListListType({data, date, pageInfo, dataHook, getQr, checked, }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const license = useSelector((state) => state.auth.license);
    const canInsert = canInsertByLicense({ license, assetCheck: true, userCheck: false });

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        const url = `/asset/${id}`;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "자산상세"),
            url,
        });
    };

    const {handleSearch, handlePageSizeChange, searchConditions, saveConditions, refresh, reload, handleGridPageChange} = dataHook;

    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [commons, setCommons] =useState(null);
    const [values, setValues] =useState(saveConditions.savedSub ?? [])
    const refreshCache = useCacheRefresh();

    const platform = useSelector(state =>state.auth.platFrom);
    const listHeader = useMemo(() => {
        const base = platform === "ITM" ? ASSET_LIST_HEADER : ASSET_IAM_LIST_HEADER;
        return withListColumnFilters(base);
    }, [platform]);

    const [header, setHeader] = useState({ order: listHeader, exclude: [] });
    const [memoTargetIds, setMemoTargetIds] = useState([]);
    const [, setExclude] = useState([]);
    const [, setPin] = useState();
    const showAssetMemo = platform === "ITAM" || platform === "IAM";

    useEffect(() => {
        setHeader({ order: listHeader, exclude: [] });
    }, [listHeader]);

    const searchDate = {startDate: saveConditions.startDate?? date.startDate ,endDate: saveConditions.endDate?? date.endDate }
    useEffect(() => {
        setValues(saveConditions.savedSub ?? []);
    }, [saveConditions.savedSub])
    useEffect(() => {
        getCommonColumns()
            .then((c) => {
                setCommons(c.data);
                return getCommonStringColumns().then((s) => ({ c, s }));
            })
            .then(({ c, s }) => {
                const commonCodes = c.data.map((e) => ({
                    name: e.name,
                    field: e.type + '_' + parseInt(e.key),
                    key: parseInt(e.key),
                    width: 140,
                    type: 'children',
                    filterable: true,
                }));
                const commonStrings = s.data.map((e) => ({
                    name: e.name,
                    field: e.type + '_' + parseInt(e.key),
                    key: parseInt(e.key),
                    width: 140,
                    type: 'children',
                    filterable: true,
                }));
                const merged = [...listHeader, ...commonCodes, ...commonStrings];
                return getIndividualSetting().then((r) => ({ r, merged }));
            })
            .then(({ r, merged }) => {
                initHeaderOrders(r, merged, setHeader, [], setExclude, setPin, 'asset');
            })
            .catch(() => {});

    },[platform, listHeader])


    const deleteAsset = (rows) => {
        if (!rows?.length) {
            alert('삭제할 데이터를 선택하세요');
            return;
        }
        if(window.confirm('삭제하시겠습니까?')) {
            const ids = rows.map((row) => row.id).filter((id) => id != null);
            deleteAssets(ids).then(r => {
                if (r.status == 200) {
                    alert("삭제되었습니다.")
                    refreshCache(CacheType.asset);
                    reload()
                } else if (r.status == 201) {
                    handleActiveError({message: r.data.title, description: r.data.reason});
                }
            })
        }
    }

    const openAssetMemo = (rows) => {
        const ids = rows.map((row) => row.id).filter((id) => id != null);
        setMemoTargetIds(ids);
        dispatch(openDrawer({key: 'AssetMemo'}));
    };

    const openQrPrint = (rows) => {
        getQr({checked: rows.map((row) => row.id).filter((id) => id != null)});
    };
    const assetListJsGridHeader = useMemo(
        () => simmsColumnsToJsGridHeaders(header),
        [header],
    );

    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);
    return (
        <div className="container-height">
            <AssetMemo id={memoTargetIds}/>
            <Search entity={'asset'} handleSearch={handleSearch} refresh={refresh} searchConditions={saveConditions} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} searchBar={{ placeHolder : '자산명, 자산코드'}} reset size detail date={searchDate} >
                <SearchSection title={'기본정보'}>
                    <Selector showLabel onChange={(value) => searchListener(handleSearch, 'project', extractObject(saveConditions), value) }
                                 data={saveConditions.project}
                                 entity={"project"} title={"시스템"}/>
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'group', extractObject(saveConditions), value) }
                                 data={saveConditions.group}
                                 parentKey={CodeSpecNum.AssetGroupCode} recursive
                                 entity={"code"} title={"자산그룹"}/>
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'task', extractObject(saveConditions), value) }
                                 data={saveConditions.task}
                                 parentKey={CodeSpecNum.TaskGroupCode} recursive
                                 entity={"code"} title={"업무그룹"}/>
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'location', extractObject(saveConditions), value) }
                                 data={saveConditions.location}
                                 parentKey={CodeSpecNum.AssetLocation} recursive
                                 entity={"code"} title={"자산위치"}/>
                    {platform === "ITM" && (
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'slaGroup', extractObject(saveConditions), value) }
                                 data={saveConditions.slaGroup}
                                 parentKey={CodeSpecNum.SlaGroupCode} recursive
                                 entity={"code"} title={"SLA 그룹"}/>
                    )}
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'department', extractObject(saveConditions), value) }
                                 data={saveConditions.department}
                                 uniqueKey={'department'}
                                 recursive
                                 entity={"department"} title={"부서"}/>
                </SearchSection>
                <SearchSection title={'유지관리'} bg={'#f6f6f6'}>
                    <Selector showLabel
                                 onChange={(value) => searchListener(handleSearch, 'operator', extractObject(saveConditions), value)}
                                 data={saveConditions.operator}
                                 uniqueKey={'operator'}
                                 entity={"userAccount"} title={"운영담당자"}>

                        <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                        <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                        <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                    </Selector>
                    <Selector showLabel
                                 onChange={(value) => searchListener(handleSearch, 'handler', extractObject(saveConditions), value)}
                                 data={saveConditions.handler}
                                 uniqueKey={'handler'}
                                 entity={"userAccount"} title={"자산사용자"}>

                        <SimmsInputSearch type={'TEXT'} placeHolder={"사용자명"} />
                        <SimmsDrawerSearch showLabel title={'부서'} entity={'department'} target={'department'} recursive />
                        <SimmsDrawerSearch showLabel title={'업체'} entity={'company'} target={'company'} />
                    </Selector>
                    <p></p>
                    <Selector showLabel
                             onChange={(value) => searchListener(handleSearch, 'mngPrimary', extractObject(saveConditions), value)}
                             data={saveConditions.mngPrimary}
                             entity={"company"} title={"1차 유지보수 업체"}>
                        <SimmsInputSearch type={'TEXT'} placeHolder={"업체명"} />
                    </Selector>
                    <Selector showLabel
                             onChange={(value) => searchListener(handleSearch, 'mngSecondary', extractObject(saveConditions), value)}
                             data={saveConditions.mngSecondary}
                             entity={"company"} title={"2차 유지보수 업체"}>
                        <SimmsInputSearch type={'TEXT'} placeHolder={"업체명"} />
                    </Selector>
                    <Selector showLabel
                              onChange={(value) => searchListener(handleSearch, 'mngTertiary', extractObject(saveConditions), value)}
                              data={saveConditions.mngTertiary}
                              entity={"company"} title={"3차 유지보수 업체"}>
                        <SimmsInputSearch type={'TEXT'} placeHolder={"업체명"} />
                    </Selector>
                </SearchSection>
                <SearchSection title={'공통코드'} >
                    {commons && commons.length > 0 && (
                        commons.map((e,index)=>(
                            <Selector showLabel key={'ss_'+index}
                                         onChange={(value) => ITER_searchListener(setValues, handleSearch,'value',  values,
                                             {subId:e.key, subName:e.type, fieldName:e.typeName, index:index},
                                             value)}
                                         data={values.find(e=>e.index===index)}
                                         parentKey={parseInt(e.key)}
                                         uniqueKey={`customCode_search_${e.key}`}
                                         entity={'customCode'} title={e.name} recursive />
                        ))
                    )}
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{ minHeight: 0, height: '100%' }}
                    header={assetListJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting( {headers: {'asset': v }})}
                    onHeaderReset={()=> resetIndividualSetting('headers','asset')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                        {/*<JsGridUploadAction onUploadConfirm={handleAssetExcelUpload} />*/}

                        <JsGridExcelGridOpenButton entityName="Asset" search={excelGridSearch} editable />
                        {/*<JsGridExcelDownloadButton onClick={handleDownloadClick('Asset')}/>*/}
                        <ToolbarDataTransfer onTransfer={openQrPrint}>
                            {(ctx) => (
                                <button
                                    type="button"
                                    className="p-0.5 border rounded-4 disabled:cursor-not-allowed disabled:opacity-50"
                                    title="QR 인쇄"
                                    disabled={ctx.disabled}
                                    onClick={() => {
                                        if (ctx.selectedCount === 0) {
                                            alert("자산을 선택하세요");
                                            return;
                                        }
                                        void ctx.transferSelected();
                                    }}
                                >
                                    <img src={QrIcon} alt="QR 인쇄" className="w-[26px] h-[26px] p-[2px]" />
                                </button>
                            )}
                        </ToolbarDataTransfer>
                        {showAssetMemo && (
                            <ToolbarDataTransfer onTransfer={openAssetMemo}>
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="p-0.5 border rounded-4 disabled:cursor-not-allowed disabled:opacity-50"
                                        title="자산기록"
                                        disabled={ctx.disabled}
                                        onClick={() => {
                                            if (ctx.selectedCount === 0) {
                                                alert("대상을 선택하세요");
                                                return;
                                            }
                                            void ctx.transferSelected();
                                        }}
                                    >
                                        <img src={MemoIcon} alt="자산기록" className="w-[26px] h-[26px]" />
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                        )}
                        <ToolbarDataTransfer
                            hint="선택 항목 삭제"
                            busyHint="삭제 중…"
                            disabledClassName={`unable-do`}
                            overlayLabel="삭제 중…"
                            onTransfer={deleteAsset}
                        >
                            {(ctx) => (
                                <button
                                    type="button"
                                    className={`text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed `}
                                    onClick={() => {
                                        if (ctx.selectedCount === 0) {
                                            alert('삭제할 데이터를 선택하세요');
                                            return;
                                        }
                                        void ctx.transferSelected();
                                    }}
                                >
                                    삭제
                                </button>
                            )}
                        </ToolbarDataTransfer>
                            <button
                                type="button"
                                className={`text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4 disabled:opacity-50 disabled:cursor-not-allowed`}
                                disabled={!canInsert}
                                title={!canInsert ? "라이선스 수량을 초과하여 등록할 수 없습니다." : undefined}
                                onClick={() => {
                                    if (!canInsert) {
                                        return;
                                    }
                                    navigate('/asset/create');
                                }}
                            >
                                등록
                            </button>
                        </div>
                    )}
                    onPageChange={handleGridPageChange}
                />
            </div>
        </div>
    );
}
export default AssetListListType;
